module.exports = __webpack_public_path__ + "media/images/entry/entry_btn1_ov-4fb25031fcd96503752d70d00b91b1ba.gif";